import { Link } from "react-router-dom";
import { ArrowUpRight, Phone, MessageCircle } from "lucide-react";
import Logo from "./Logo";
import { CONTACT } from "@/data/site";

export default function Footer() {
  return (
    <footer className="bg-ink text-white" data-testid="footer">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12 py-20 lg:py-28">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <Logo className="h-20" white />
            <p className="mt-6 max-w-md text-white/60 leading-relaxed">
              Equinoxe Studio. Filiale du{" "}
              <a href={CONTACT.groupUrl} target="_blank" rel="noreferrer" className="text-violet-light hover-line">
                {CONTACT.group}
              </a>
              . Basé à {CONTACT.city} ({CONTACT.postal}).
            </p>
            <p className="mt-4 text-white/40 text-sm max-w-md">
              Depuis 2004 — anciennement Garuda Productions puis Ki-An Studio.
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="text-white/40 text-xs tracking-[0.25em] uppercase mb-5">Navigation</p>
            <ul className="space-y-3">
              {[
                { to: "/services", l: "Services" },
                { to: "/a-propos", l: "À propos" },
                { to: "/contact", l: "Contact" },
                { to: "/mentions-legales", l: "Mentions légales" },
              ].map((i) => (
                <li key={i.to}>
                  <Link to={i.to} className="text-white/80 hover:text-violet-light transition-colors hover-line">
                    {i.l}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="text-white/40 text-xs tracking-[0.25em] uppercase mb-5">Contact</p>
            <a href={`tel:${CONTACT.phoneRaw}`} className="flex items-center gap-3 text-white/80 hover:text-violet-light transition-colors mb-4">
              <Phone size={16} /> {CONTACT.phone}
            </a>
            <a
              href={`https://wa.me/${CONTACT.whatsapp.replace("+", "")}`}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-3 text-white/80 hover:text-violet-light transition-colors"
            >
              <MessageCircle size={16} /> WhatsApp 24/7
            </a>
            <p className="mt-4 text-white/40 text-sm">{CONTACT.hours}</p>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-white/40 text-sm">© {new Date().getFullYear()} Equinoxe Studio. Tous droits réservés.</p>
          <a
            href={CONTACT.groupUrl}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1 text-white/50 hover:text-white text-sm transition-colors"
            data-testid="footer-group-link"
          >
            Découvrir le Groupe Equinoxe <ArrowUpRight size={15} />
          </a>
        </div>
      </div>
    </footer>
  );
}
